// extracted by mini-css-extract-plugin
module.exports = {"lenkepanel":"FormIntermediateStepLink_lenkepanel__Y3bf6","metadata":"FormIntermediateStepLink_metadata__TAWlk"};